import { useEffect, useState } from 'react';
import { api } from '../api';

export function AdminPage() {
  const [config, setConfig] = useState<Awaited<ReturnType<typeof api.adminConfig>> | null>(null);
  const [domains, setDomains] = useState<{ id: string; name: string; notes: string | null }[]>([]);
  const [newDomain, setNewDomain] = useState('');
  const [newNotes, setNewNotes] = useState('');

  function refresh() {
    api.adminConfig().then(setConfig);
    api.adminDomains().then((d) => setDomains(d.domains));
  }
  useEffect(refresh, []);

  async function addDomain(e: React.FormEvent) {
    e.preventDefault();
    if (!newDomain) return;
    await api.adminAddDomain({ name: newDomain, notes: newNotes || undefined });
    setNewDomain('');
    setNewNotes('');
    refresh();
  }

  async function removeDomain(id: string) {
    if (!confirm('Remove this domain?')) return;
    await api.adminDeleteDomain(id);
    refresh();
  }

  return (
    <>
      <div className="card">
        <h2>Configuration</h2>
        {config && (
          <dl className="kv">
            <dt>Allowed emails</dt><dd>{config.allowedEmails.join(', ') || '—'}</dd>
            <dt>Allowed groups</dt><dd>{config.allowedGroupIds.join(', ') || '—'}</dd>
            <dt>Graph mode</dt><dd>{config.graph.mode}</dd>
            <dt>Mailbox</dt><dd>{config.graph.mailboxUser ?? '—'}</dd>
            <dt>Inbox folder</dt><dd>{config.graph.inboxFolder}</dd>
            <dt>Processed folder</dt><dd>{config.graph.processedFolder}</dd>
            <dt>Polling</dt><dd>{config.graph.intervalSeconds}s</dd>
          </dl>
        )}
      </div>
      <div className="card">
        <h2>Tracked domains</h2>
        <form onSubmit={addDomain} className="flex">
          <input
            placeholder="example.com"
            value={newDomain}
            onChange={(e) => setNewDomain(e.target.value)}
          />
          <input
            placeholder="Notes (optional)"
            value={newNotes}
            onChange={(e) => setNewNotes(e.target.value)}
          />
          <button>Add</button>
        </form>
        <table style={{ marginTop: 16 }}>
          <thead>
            <tr><th>Domain</th><th>Notes</th><th></th></tr>
          </thead>
          <tbody>
            {domains.map((d) => (
              <tr key={d.id}>
                <td>{d.name}</td>
                <td className="muted">{d.notes ?? '—'}</td>
                <td><button className="secondary" onClick={() => removeDomain(d.id)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
